import type { Locale } from '~/i18n';

type LocalizedSongTitleSource = {
  title: string;
  englishName?: string;
};

function getTrailingVariant(title: string) {
  return title.match(/([（(][^()（）]+[）)])+$/u)?.[0];
}

export function getLocalizedSongTitle(song: LocalizedSongTitleSource, locale: Locale) {
  if (!locale.startsWith('en') || !song.englishName) {
    return song.title;
  }

  const trailingVariant = getTrailingVariant(song.title);
  if (!trailingVariant || song.englishName.endsWith(trailingVariant)) {
    return song.englishName;
  }

  return `${song.englishName}${trailingVariant}`;
}
